import React, { useState, useEffect, useCallback } from "react";
import dayjs from 'dayjs';
import { PageBase } from "../../Components/PageBase";
import { useRol } from '../../Context';
import "./Tareas.css";
import iconSvg from '../../icons/add-circle.svg';
import iconSVG from "../../icons/briefcase.svg";
import tareasNA from '../../icons/TareasNA.svg';
import tasksPanelEmpty from '../../icons/tasks-schedule.png';
import img from "../../icons/close.svg";
import Modal from '../../Components/Modal';
import img2 from "../../icons/calendar-number-outline.svg";
import filterTaskMovil from "../../icons/funnel.svg";
import repeat from "../../icons/repeat.svg";
import repeat2 from '../../icons/repeat (1).svg';
import checkmark from '../../icons/checkmark.svg';
import checkmark2 from '../../icons/checkmark (1).svg';
import personTask from '../../icons/person-sharp (1).svg';
import logoWhatsApp from '../../icons/logo-whatsapp.svg';
import phone from '../../icons/call copy.svg'

function Tareas() {
    const {
        rol,
        tasksOpen,
        tasksFinished,
        dataProfile,
        setIdTask,
        task,
        setTask_Status,
        handlePosthTasksByLeadRequest,
        handlePatchTasksRequest,
        title,
        setTitle,
        description,
        setDescription,
        expiration,
        setExpiration,
        handleClickFinalizada,
        handleClickProceso,
        setTasksOpen,
        fetchTasks,
        listaUsers,
        tasksCoord,
        facturacion
    } = useRol();

    let user = dataProfile ? dataProfile.first_name : "User";
    let nombreCompleto = dataProfile ? dataProfile.first_name + " " + dataProfile.last_name : "User"

    const [activeTab, setActiveTab] = useState('pendientes');

    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);

    const toggleDiv = () => {
        setTitleError('')
        setExpirationError('')
        setDescriptionError('')
        setIsOpen((prevIsOpen) => {
            if (isOpen2 || isOpen3) {
                setIsOpen2(false);
                setIsOpen3(false);
            }
            return !prevIsOpen;
        });
    };

    const toggleDiv2 = (taskId) => {
        setIsOpen2((prevIsOpen2) => {
            if (prevIsOpen2) {
                setIdTask(taskId);
                return true;
            }

            if (isOpen || isOpen3) {
                setIsOpen(false);
                setIsOpen3(false);
            }

            setIdTask(taskId);
            return true;
        });
    };

    const toggleDiv3 = (taskId) => {
        setIsOpen3((prevIsOpen3) => {
            if (prevIsOpen3) {
                setIdTask(taskId);
                return true;
            }

            if (isOpen || isOpen2) {
                setIsOpen(false);
                setIsOpen2(false);
            }

            setIdTask(taskId);
            return true;
        });
    };

    useEffect(() => {
        setTitle(task ? task.title : '')
        setExpiration(task ? task.expiration : null)
        setDescription(task ? task.description : '')
    }, [task, setTitle, setExpiration, setDescription])

    // Modal **MOVIL** agregar tarea
    const [isModalOpenAddTarea, setIsModalOpenAddTarea] = useState(false);
    const openModalAddTarea = () => {
        setIsModalOpenAddTarea(true);
    };
    const closeModalAddTarea = () => {
        setIsModalOpenAddTarea(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** filtrar tareas
    const [isModalOpenFilterTarea, setIsModalOpenFilterTarea] = useState(false);
    const openModalFilterTarea = () => {
        setIsModalOpenFilterTarea(true);
    };
    const closeModalFilterTarea = () => {
        setIsModalOpenFilterTarea(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** tareas pendientes
    const [isModalOpenPendientTarea, setIsModalOpenPendientTarea] = useState(false);
    const openModalPendientTarea = () => {
        setIsModalOpenPendientTarea(true);
    };
    const closeModalPendientTarea = () => {
        setIsModalOpenPendientTarea(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** tareas pendientes
    const [isModalOpenFinishTarea, setIsModalOpenFinishTarea] = useState(false);
    const openModalFinishTarea = () => {
        setIsModalOpenFinishTarea(true);
    };
    const closeModalFinishTarea = () => {
        setIsModalOpenFinishTarea(false);
        document.body.style.overflow = 'visible';
    };

    //const [filteredTasks, setFilteredTasks] = useState([]);


    const handleDate2Change = (e) => {
        const selectedDate = e.target.value;
        const adjustedDate = new Date(selectedDate + 'T00:00:00Z');
        const formattedDate = formatDate(adjustedDate);
        setExpiration(formattedDate);
    };

    const formatDate = (dateObject) => {
        const year = dateObject.getUTCFullYear();
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0');
        const day = String(dateObject.getUTCDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const day = today.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const filterTasksByExpiration = (condition) => {
        return tasksOpen?.filter(task => task.expiration != null && condition(task.expiration)) || [];
    };

    const [tasksToday, setTasksToday] = useState([]);
    const [tasksThisWeek, setTasksThisWeek] = useState([]);
    const [tasksThisMonth, setTasksThisMonth] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState('total');

    const filteredTasks = useCallback(() => {
        switch (selectedFilter) {
            case 'today':
                return tasksToday || [];
            case 'week':
                return tasksThisWeek || [];
            case 'month':
                return tasksThisMonth || [];
            case 'total':
                return tasksOpen || [];
            default:
                return tasksOpen || [];
        }
    }, [selectedFilter, tasksOpen, tasksToday, tasksThisWeek, tasksThisMonth])

    useEffect(() => {
        const currentDate = getCurrentDate();
        setTasksToday(filterTasksByExpiration(expiration => expiration === currentDate));

        const endOfWeek = new Date();
        endOfWeek.setDate(endOfWeek.getDate() + 7);
        const endOfWeekFormatted = getCurrentDate(endOfWeek);

        const weekTasks = filterTasksByExpiration(expiration => expiration >= currentDate && expiration <= endOfWeekFormatted);
        setTasksThisWeek(weekTasks);

        const currentMonthTasks = filterTasksByExpiration(expiration => expiration.startsWith(currentDate.slice(0, 7)));
        setTasksThisMonth(currentMonthTasks);

        setTasksOpen(prevTasks => [...(prevTasks || [])].sort((a, b) => {
            const dateA = new Date(a.expiration);
            const dateB = new Date(b.expiration);
            return dateB - dateA;
        }));

    }, [filterTasksByExpiration, setTasksOpen]);

    const handleContainerClick = (filter) => {
        setSelectedFilter(filter);
    };

    const [titleError, setTitleError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [expirationError, setExpirationError] = useState('');

    const [asesores, setAsesores] = useState([])

    useEffect(() => {
        setAsesores(listaUsers)
    }, [listaUsers])

    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('Abierta');
    const [searchTask, setSearchTask] = useState('');
    const [filteredTasksCoord, setFilteredTasksCoord] = useState([]);

    const applyFilters = useCallback(() => {
        const today = new Date();
        const endOfWeek = new Date(today);
        endOfWeek.setDate(today.getDate() + 7);

        let filteredResult = tasksCoord || [];

        if (selectedMonth !== 'Total') {
            filteredResult = filteredResult.filter(({ expiration }) => {
                const expirationDate = new Date(expiration);
                return expirationDate.getMonth() + 1 === selectedMonth;
            });
        }

        if (selectedYear !== 'Total') {
            filteredResult = filteredResult.filter(({ expiration }) => {
                const expirationDate = new Date(expiration);
                return expirationDate.getFullYear() === selectedYear;
            });
        }

        if (selectedUserId !== null) {
            filteredResult = filteredResult.filter(task => task.responsable === selectedUserId);
        }

        if (selectedStatus !== 'Total') {
            filteredResult = filteredResult.filter(task => task.task_status === selectedStatus);
        }

        if (searchTask.trim()) {
            const q = searchTask.trim().toLowerCase();
            filteredResult = filteredResult.filter(task =>
                task.title?.toLowerCase().includes(q) ||
                task.description?.toLowerCase().includes(q)
            );
        }

        if (selectedMonth === 'today') {
            filteredResult = filteredResult.filter(({ expiration }) => {
                const expirationDate = new Date(expiration);
                return (
                    expirationDate.getDate() === today.getDate() &&
                    expirationDate.getMonth() === today.getMonth() &&
                    expirationDate.getFullYear() === today.getFullYear()
                );
            });
        }

        if (selectedMonth === 'thisWeek') {
            filteredResult = filteredResult.filter(({ expiration }) => {
                const expirationDate = new Date(expiration);
                return expirationDate >= today && expirationDate <= endOfWeek;
            });
        }

        setFilteredTasksCoord(filteredResult);
    }, [selectedMonth, selectedUserId, selectedYear, selectedStatus, searchTask, tasksCoord]);


    useEffect(() => {
        applyFilters();
    }, [applyFilters]);

    const handleMonthChange = (e) => {
        const val = e.target.value;
        const parsed = ['today', 'thisWeek', 'Total'].includes(val) ? val : parseInt(val);
        setSelectedMonth(parsed);
        if (val === 'Total') setSelectedYear('Total');
    };

    const handleYearChange = (e) => {
        const val = e.target.value;
        const parsed = val === 'Total' ? val : parseInt(val);
        setSelectedYear(parsed);
        if (val === 'Total') setSelectedMonth('Total');
    };

    const handleFilterButtonClick = () => {
        applyFilters();
    };

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="tareas-task">
                    {rol === 'Asesor' && <div>
                        <div className="cards">
                            <div className="container-card" onClick={() => handleContainerClick('today')}>
                                <span>{tasksToday.length}</span>
                                <label>HOY</label>
                            </div>
                            <div className="container-card" onClick={() => handleContainerClick('week')}>
                                <span>{tasksThisWeek.length}</span>
                                <label>SEMANA</label>
                            </div>
                            <div className="container-card" onClick={() => handleContainerClick('month')}>
                                <span>{tasksThisMonth.length}</span>
                                <label>MES</label>
                            </div>
                            <div className="container-card" onClick={() => handleContainerClick('total')}>
                                <span>{tasksOpen.length}</span>
                                <label>TOTAL</label>
                            </div>
                        </div>
                    </div>}
                    {['Coordinador', 'Asesor'].includes(rol) && <div className="all">
                        <div className="indicadores-coord-wrapper">
                            <div className="indicadores-coord-header">
                                <div className="indicadores-coord-header-text">
                                    <label>Revisa las tareas de seguimiento</label>
                                    <span>Gestiona a tu equipo dando seguimiento a las tareas que realizan en cada etapa del proceso de venta.</span>
                                </div>
                            </div>
                            <div className="filtrosTask-container">
                                {rol !== 'Asesor' && (
                                    <div className="filterTask selectTask">
                                        <select className="equipo-periodo-select" value={selectedUserId} onChange={(e) => setSelectedUserId(parseInt(e.target.value))}>
                                            <optgroup label={facturacion?.[0]?.vacant_name}>
                                                {asesores?.map((user) => (<option key={user.id} value={user.id}>{user.first_name + ' ' + user.last_name}</option>))}
                                            </optgroup>
                                        </select>
                                    </div>
                                )}
                                <div className="filterTask selectTask">
                                    <select className="equipo-periodo-select" value={selectedMonth} onChange={handleMonthChange}>
                                        <option value="today">Hoy</option>
                                        <option value="thisWeek">Semana</option>
                                        <option value="Total">Total</option>
                                        <option value="1">Enero</option>
                                        <option value="2">Febrero</option>
                                        <option value="3">Marzo</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Mayo</option>
                                        <option value="6">Junio</option>
                                        <option value="7">Julio</option>
                                        <option value="8">Agosto</option>
                                        <option value="09">Septiembre</option>
                                        <option value="10">Octubre</option>
                                        <option value="11">Noviembre</option>
                                        <option value="12">Diciembre</option>
                                    </select>
                                </div>
                                <div className="filterTask selectTask">
                                    <select className="equipo-periodo-select" onChange={handleYearChange} value={selectedYear}>
                                        <option value="Total">Total</option>
                                        <option value="2020">2020</option>
                                        <option value="2021">2021</option>
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                    </select>
                                </div>
                                <div className="filterTask selectTask">
                                    <select className="equipo-periodo-select" value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                                        <option value="Abierta">Pendientes</option>
                                        <option value="Finalizada">Finalizadas</option>
                                    </select>
                                </div>
                                <div className="filterTask filterTask--search">
                                    <div className="equipo-search-wrapper">
                                        <input
                                            type="text"
                                            placeholder="Busca por título o descripción de la tarea"
                                            value={searchTask}
                                            onChange={(e) => setSearchTask(e.target.value)}
                                        />
                                        <svg className="equipo-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="11" cy="11" r="8"></circle>
                                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    <div className="container-flex-tareas">
                        <div className="col col-6 container-task">
                            {(rol === 'Asesor' ? filteredTasks() : filteredTasksCoord).length > 0 && (
                                <div className="cabecera">
                                    <div className="add-boton">
                                        <button onClick={() => {
                                            toggleDiv()
                                            setTitle('')
                                            setExpiration('')
                                            setDescription('')
                                        }}>
                                            <img src={iconSvg} alt="+" />
                                            <label>Añadir nueva tarea</label>
                                        </button>
                                    </div>
                                </div>
                            )}
                            <div className="content">
                                {(rol === 'Asesor' ? filteredTasks() : filteredTasksCoord).length === 0 && (
                                    <div className="col-panel-task-empty">
                                        <img src={tareasNA} alt="Sin tareas" className="col-panel-task-empty-img" />
                                        <div className="col-panel-task-empty-text">
                                            <label>Aún no hay tareas creadas</label>
                                            <span>{rol === 'Asesor' ? 'Selecciona una tarea o crea una nueva.' : 'Consulta con tu asesor el seguimiento a través de tareas.'}</span>
                                        </div>
                                        <button className="add-boton-empty" onClick={() => {
                                            toggleDiv()
                                            setTitle('')
                                            setExpiration('')
                                            setDescription('')
                                        }}>
                                            <img src={iconSvg} alt="+" />
                                            <label>Añadir nueva tarea</label>
                                        </button>
                                    </div>
                                )}
                                <table className="equipo-table">
                                    <tbody>
                                        {(rol === 'Asesor' ? (filteredTasks() || []) : (filteredTasksCoord || []))
                                            .map(task => {
                                                const asesor = asesores?.find(a => a.id === task.responsable);
                                                return (
                                                    <tr key={task.id} onClick={() => toggleDiv2(task.id)} style={{ cursor: 'pointer' }}>
                                                        <td>
                                                            <div className="equipo-asesor-cell">
                                                                <div className="equipo-asesor-avatar">
                                                                    {asesor ? `${asesor.first_name?.[0]?.toUpperCase()}${asesor.last_name?.[0]?.toUpperCase()}` : nombreCompleto.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)}
                                                                </div>
                                                                <div className="equipo-asesor-info">
                                                                    <label>{task.title}</label>
                                                                    <span>{task.description ? (task.description.length > 70 ? task.description.slice(0, 70) + '…' : task.description) : 'Sin descripción'}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="equipo-actividad">
                                                                <span>{dayjs(task.expiration).format('DD/MM/YY')}</span>
                                                                <span className="equipo-actividad-label">Vencimiento</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col col-6 col-panel-task">
                        {isOpen && (
                            <>
                                <div className="cabecera card2">
                                    <div className="head-task-label">
                                        <label>Crea una nueva tarea</label>
                                    </div>
                                    <div className="head-task-icon">
                                        <button onClick={toggleDiv}><img src={img} alt="X" /></button>
                                    </div>
                                </div>
                                <div className="body-card2-task">
                                    <div className="body-card2-task-input">
                                        <input
                                            type="text"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Escribe un nombre para la tarea"
                                            required
                                        />
                                        {titleError && <span className="error-message">{titleError}</span>}
                                    </div>
                                    <div className="card2-data-container">
                                        {document.querySelectorAll('.cuadrado').forEach((element) => {
                                            const text = element.textContent;
                                            const firstLetter = document.createElement('span');
                                            firstLetter.className = 'inicial';
                                            firstLetter.textContent = text[0];
                                            element.textContent = '';
                                            element.appendChild(firstLetter);
                                        })}
                                        <div className="cuadrado inicial">
                                            <label>{user}</label>
                                        </div>
                                        <div className="container-data-asesor">
                                            <div className="card2-data-asesor">
                                                <label>Asignada a:</label>
                                                <label>{nombreCompleto}</label>
                                            </div>
                                            <div className="card2-data-asesor-date">
                                                <div className="card2-icon-calendar">
                                                    <img src={img2} alt="calendar" />
                                                </div>
                                                <div className="date-data-div2">
                                                    <label>Fecha de término:</label>
                                                    <input
                                                        type="date"
                                                        value={expiration}
                                                        onChange={handleDate2Change}
                                                        required
                                                    />
                                                </div>
                                                {expirationError && <span className="error-message">{expirationError}</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="div2-textarea">
                                        <textarea
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Descripción..."
                                            required
                                        ></textarea>
                                        {descriptionError && <span className="error-message">{descriptionError}</span>}
                                    </div>
                                    <div className="div2-btn">
                                        <button
                                            className="addProyecto-btn"
                                            onClick={() => {
                                                if (!title) {
                                                    setTitleError('Este campo es obligatorio');
                                                } else {
                                                    setTitleError('');
                                                }

                                                if (!description) {
                                                    setDescriptionError('Este campo es obligatorio');
                                                } else {
                                                    setDescriptionError('');
                                                }

                                                if (!expiration) {
                                                    setExpirationError('Este campo es obligatorio');
                                                } else {
                                                    setExpirationError('');
                                                }

                                                if (title && description && expiration) {
                                                    setTask_Status('Abierta');
                                                    handlePosthTasksByLeadRequest();
                                                    setTimeout(() => {
                                                        fetchTasks()
                                                        toggleDiv();
                                                    }, 1000);
                                                }
                                            }}
                                        >
                                            Crear tarea
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                        {isOpen2 && (
                            <>
                                <div className="cabecera card2">
                                    <div className="head-task-label">
                                        <label>Editar tarea</label>
                                    </div>
                                    <div className="head-task-icon">
                                        <button onClick={() => setIsOpen2(false)}><img src={img} alt="X" /></button>
                                    </div>
                                </div>
                                <div className="body-card2-task">
                                    <div className="body-card2-task-input">
                                        <div className="task-input-row">
                                            <input
                                                type="text"
                                                value={title}
                                                onChange={(e) => setTitle(e.target.value)}
                                                required
                                            />
                                            {task?.task_status === 'Finalizada' ? (
                                                <button className="finish-task-btn" onClick={() => {
                                                    handleClickFinalizada();
                                                }}>
                                                    <img src={checkmark} alt="checkmark" className="imagen-estandar" />
                                                    <img src={checkmark2} alt="checkmark2" className="imagen-oculta" />
                                                    Finalizado
                                                </button>
                                            ) : (
                                                <button className="btn-en-proceso" onClick={() => {
                                                    handleClickProceso();
                                                    setTimeout(() => {
                                                        setActiveTab('finalizadas');
                                                    }, 1000);
                                                }}>
                                                    <img src={repeat} alt="repeat" className="imagen-estandar" />
                                                    <img src={repeat2} alt="repeat2" className="imagen-oculta" />
                                                    En proceso
                                                </button>
                                            )}
                                        </div>
                                        {titleError && <span className="error-message">{titleError}</span>}
                                    </div>
                                    <div className="card2-data-container">
                                        {document.querySelectorAll('.cuadrado').forEach((element) => {
                                            const text = element.textContent;
                                            const firstLetter = document.createElement('span');
                                            firstLetter.className = 'inicial';
                                            firstLetter.textContent = text[0];
                                            element.textContent = '';
                                            element.appendChild(firstLetter);
                                        })}
                                        <div className="cuadrado inicial">
                                            <label>{user}</label>
                                        </div>
                                        <div className="container-data-asesor">
                                            <div className="card2-data-asesor">
                                                <label>Asignada a:</label>
                                                <label>{nombreCompleto}</label>
                                            </div>
                                            <div className="card2-data-asesor-date">
                                                <div className="card2-icon-calendar">
                                                    <img src={img2} alt="calendar" />
                                                </div>
                                                <div className="date-data-div2">
                                                    <label>Fecha de término:</label>
                                                    <input
                                                        type="date"
                                                        value={expiration}
                                                        onChange={handleDate2Change}
                                                        required
                                                    />
                                                </div>
                                                {expirationError && <span className="error-message">{expirationError}</span>}
                                            </div>
                                        </div>
                                    </div>
                                    {task?.type_task !== "" &&
                                        <div className="buttons-prospects-tasks">
                                            <button className="btn-prosp">
                                                <img src={personTask} alt="personTask" />
                                                <label>{task ? task.candidate : "Prospecto"}</label>
                                            </button>
                                            <button className="btn-contac">
                                                {task?.type_task === 'Teléfono' && <img src={phone} alt="telefono" />}
                                                {task?.type_task === 'Whatsapp' && <img src={logoWhatsApp} alt="logoWhatsApp" />}
                                                <label>{task ? task.type_task : null}</label>
                                            </button>
                                        </div>}
                                    <div className="div2-textarea">
                                        <label>Descripción</label>
                                        <textarea
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        ></textarea>
                                        {descriptionError && <span className="error-message">{descriptionError}</span>}
                                    </div>
                                    <div className="div2-btn">
                                        <button className="addProyecto-btn" onClick={() => {
                                            if (!title) {
                                                setTitleError('Este campo es obligatorio');
                                            } else {
                                                setTitleError('');
                                            }

                                            if (!description) {
                                                setDescriptionError('Este campo es obligatorio');
                                            } else {
                                                setDescriptionError('');
                                            }

                                            if (!expiration) {
                                                setExpirationError('Este campo es obligatorio');
                                            } else {
                                                setExpirationError('');
                                            }
                                            if (title && description && expiration) {
                                                handlePatchTasksRequest();
                                                setTimeout(() => {
                                                    fetchTasks()
                                                    setIsOpen2(false);
                                                }, 1000);
                                            }
                                        }}>Editar tarea</button>
                                    </div>
                                </div>
                            </>
                        )}
                        {isOpen3 && (
                            <>
                                <div className="cabecera card2">
                                    <div className="head-task-label">
                                        <button onClick={() => {
                                            handleClickFinalizada()
                                            setTimeout(() => {
                                                setActiveTab('pendientes');
                                            }, 1000);
                                        }} className="finish-task-btn">
                                            <img src={checkmark} alt="checkmark" class="imagen-estandar" />
                                            <img src={checkmark2} alt="checkmark2" class="imagen-oculta" />
                                            Finalizada
                                        </button>
                                    </div>
                                    <div className="head-task-icon">
                                        <button onClick={() => setIsOpen3(false)}><img src={img} alt="X" /></button>
                                    </div>
                                </div>
                                <div className="body-card2-task">
                                    <div className="body-card2-task-input">
                                        <label>{task ? task.title : "title"}</label>
                                    </div>
                                    <div className="card2-data-container">
                                        {document.querySelectorAll('.cuadrado').forEach((element) => {
                                            const text = element.textContent;
                                            const firstLetter = document.createElement('span');
                                            firstLetter.className = 'inicial';
                                            firstLetter.textContent = text[0];
                                            element.textContent = '';
                                            element.appendChild(firstLetter);
                                        })}
                                        <div className="cuadrado inicial">
                                            <label>{user}</label>
                                        </div>
                                        <div className="container-data-asesor">
                                            <div className="card2-data-asesor">
                                                <label>Asignada a:</label>
                                                <label>{nombreCompleto}</label>
                                            </div>
                                            <div className="card2-data-asesor-date">
                                                <div className="card2-icon-calendar">
                                                    <img src={img2} alt="calendar" />
                                                </div>
                                                <div className="date-data-div2">
                                                    <label>Fecha de término:</label>
                                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {task?.type_task !== "" &&
                                        <div className="buttons-prospects-tasks">
                                            <button className="btn-prosp">
                                                <img src={personTask} alt="personTask" />
                                                <label>{task ? task.candidate : "Prospecto"}</label>
                                            </button>
                                            <button className="btn-contac">
                                                {task?.type_task === 'Teléfono' && <img src={phone} alt="telefono" />}
                                                {task?.type_task === 'Whatsapp' && <img src={logoWhatsApp} alt="logoWhatsApp" />}
                                                <label>{task ? task.type_task : null}</label>
                                            </button>
                                        </div>}
                                    <div className="div2-textarea">
                                        <label>Descripción</label>
                                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                                    </div>
                                    <div className="div2-btn">
                                        <button className="addProyecto-btn" onClick={() => {
                                            handlePatchTasksRequest();
                                            setTimeout(() => {
                                                fetchTasks()
                                                setIsOpen3(false);
                                            }, 1000);
                                        }}>Editar tarea</button>
                                    </div>
                                </div>
                            </>
                        )}
                        {!isOpen && !isOpen2 && !isOpen3 && (
                            <div className="col-panel-task-right-empty">
                                <img src={tasksPanelEmpty} alt="Sin tarea seleccionada" className="col-panel-task-right-empty-img" />
                                <div className="col-panel-task-empty-text">
                                    <label>Comienza a gestionar con tareas</label>
                                    <span>Crea o selecciona una tarea para el seguimiento a tus contactos.</span>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="tareas-movil">
                <div className="container-main-movil">
                    {rol === 'Asesor' && <div>
                        <div className="tareas-container-cards-movil">
                            <div className="tareas-card-movil" onClick={() => handleContainerClick('today')}>
                                <span>{tasksToday.length}</span>
                                <label>HOY</label>
                            </div>
                            <div className="tareas-card-movil" onClick={() => handleContainerClick('week')}>
                                <span>{tasksThisWeek.length}</span>
                                <label>SEMANA</label>
                            </div>
                            <div className="tareas-card-movil" onClick={() => handleContainerClick('month')}>
                                <span>{tasksThisMonth.length}</span>
                                <label>MES</label>
                            </div>
                            <div className="tareas-card-movil" onClick={() => handleContainerClick('total')}>
                                <span>{tasksOpen.length}</span>
                                <label>TOTAL</label>
                            </div>
                        </div>
                        <div className="container-tareas-movil">
                            <div className="button-container-tareas-movil">
                                <button onClick={() => {
                                    openModalAddTarea()
                                    setTitle('')
                                    setExpiration('')
                                    setDescription('')
                                }}>
                                    <img src={iconSvg} alt="+" />
                                    <label>Añadir nueva tarea</label>
                                </button>
                            </div>
                            <div className="container-filtrosTask-movil">
                                <div className={`movil-tab ${activeTab === 'pendientes' ? 'active' : ''}`} onClick={() => setActiveTab('pendientes')}>
                                    <label>Pendientes</label>
                                </div>
                                <div className={`movil-tab ${activeTab === 'finalizadas' ? 'active' : ''}`} onClick={() => setActiveTab('finalizadas')}>
                                    <label>Finalizadas</label>
                                </div>
                            </div>
                            <div className="content-movil">
                                {activeTab === 'pendientes' && <div className="container-pendientes-movil">
                                    {filteredTasks()
                                        .map(task => (
                                            <div className="task-movil" key={task.id}>
                                                <div className="task-container-column-movil" onClick={openModalPendientTarea}>
                                                    <div className="name-task-movil">
                                                        <label>{task.title}</label>
                                                    </div>
                                                    <div className="data-task-movil">
                                                        <label className="date-movil">{task.expiration}</label>
                                                        <label className="encargado-movil">{user}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>}
                                {activeTab === 'finalizadas' && <div className="container-finalizadas-movil">
                                    {(tasksFinished || [])
                                        .map(task => (
                                            <div className="task-movil" key={task.id}>
                                                <div className="task-container-column-movil" onClick={openModalFinishTarea}>
                                                    <div className="name-task-movil">
                                                        <label>{task.title}</label>
                                                    </div>
                                                    <div className="data-task-movil">
                                                        <label className="date-movil">{task.expiration}</label>
                                                        <label className="encargado-movil">{user}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>}
                            </div>
                        </div>
                    </div>}
                    {rol === 'Coordinador' && <div>
                        <div className="container-tareas-movil">
                            <div className="button-container-tareas-movil">
                                <button onClick={openModalAddTarea}>
                                    <img src={iconSvg} alt="+" />
                                    <label>Añadir nueva tarea</label>
                                </button>
                            </div>
                            <div className="container-filtrosTask-movil">
                                <div className={`movil-tab ${activeTab === 'pendientes' ? 'active' : ''}`} onClick={() => setActiveTab('pendientes')}>
                                    <label>Pendientes</label>
                                </div>
                                <div className={`movil-tab ${activeTab === 'finalizadas' ? 'active' : ''}`} onClick={() => setActiveTab('finalizadas')}>
                                    <label>Finalizadas</label>
                                </div>
                                <div className="container-button-filter-task-movil">
                                    <button onClick={openModalFilterTarea}>
                                        <img src={filterTaskMovil} alt="filterTaskMovil" />
                                    </button>
                                </div>
                            </div>
                            <div className="content-movil">
                                {activeTab === 'pendientes' && <div className="container-pendientes-movil">
                                    <div className="task-movil">
                                        <div className="task-icon-movil" onClick={openModalPendientTarea}>
                                            <img src={iconSVG} alt="briefcase" />
                                        </div>
                                        <div className="task-container-column-movil" onClick={openModalPendientTarea}>
                                            <div className="name-task-movil">
                                                <label>segunda tarea</label>
                                            </div>
                                            <div className="data-task-movil">
                                                <label className="date-movil">2023-Mar-09</label>
                                                <label className="encargado-movil">Rodrigo</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {activeTab === 'finalizadas' && <div className="container-finalizadas-movil">
                                    <div className="task-movil">
                                        <div className="task-icon-movil" onClick={openModalFinishTarea}>
                                            <img src={iconSVG} alt="briefcase" />
                                        </div>
                                        <div className="task-container-column-movil" onClick={openModalFinishTarea}>
                                            <div className="name-task-movil">
                                                <label>tarea prueba</label>
                                            </div>
                                            <div className="data-task-movil">
                                                <label className="date-movil">2023-Ene-07</label>
                                                <label className="encargado-movil">Rodrigo</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <Modal isOpen={isModalOpenAddTarea} onClose={closeModalAddTarea}>
                <div className="modal-title">
                    <label>CREAR TAREA</label>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <input placeholder="Escribe un nombre para la tarea" />
                    </div>
                    <div className="card2-data-container">
                        <div className="container-data-asesor">
                            <div className="cuadrado inicial">
                                <label>R</label>
                            </div>
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>Rodrigo Lopez</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="div2-textarea">
                        <textarea placeholder="Descripción..."></textarea>
                    </div>
                </div>
                <div className="buttons-container-modal">
                    <button className="btn-acept-modal">Crear tarea</button>
                </div>
            </Modal>
            <Modal isOpen={isModalOpenFilterTarea} onClose={closeModalFilterTarea}>
                <div className="modal-title">
                    <label>Filtros</label>
                </div>
                <div className="container-filtros-task-modal">
                    <label>Asesor</label>
                    <select>
                        <option value="1">Carlos Ruis</option>
                    </select>
                    <label>Mes</label>
                    <select>
                        <option value="todos">Todos</option>
                        <option value="hoy">Hoy</option>
                        <option value="semana">Semana</option>
                        <option value="enero">Enero</option>
                        <option value="febrero">Febrero</option>
                        <option value="marzo">Marzo</option>
                        <option value="abril">Abril</option>
                        <option value="mayo">Mayo</option>
                        <option value="junio">Junio</option>
                        <option value="julio">Julio</option>
                        <option value="agosto">Agosto</option>
                        <option value="septiembre">Septiembre</option>
                        <option value="octubre">Octubre</option>
                        <option value="noviembre">Noviembre</option>
                        <option value="diciembre">Diciembre</option>
                    </select>
                    <label>Año</label>
                    <select>
                        <option value="">2023</option>
                        <option value="">2022</option>
                        <option value="">2021</option>
                        <option value="">2020</option>
                        <option value="">Todos</option>
                    </select>
                </div>
                <div className="buttons-container-modal">
                    <button className="btn-acept-modal">Aplicar filtros</button>
                </div>
            </Modal>
            <Modal isOpen={isModalOpenPendientTarea} onClose={closeModalPendientTarea}>
                <div className="modal-title">
                    <div className="head-task-label">
                        <button>
                            <img src={repeat} alt="repeat" class="imagen-estandar" />
                            En proceso
                        </button>
                    </div>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <label>segunda tarea</label>
                    </div>
                    <div className="card2-data-container">
                        <div className="container-data-asesor">
                            <div className="cuadrado inicial">
                                <label>R</label>
                            </div>
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>Rodrigo Lopez</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {rol === 'Coordinador' && <div className="buttons-prospects-tasks">
                        <button className="btn-prosp">
                            <img src={personTask} alt="personTask" />
                            <label>Prospecto</label>
                        </button>
                        <button className="btn-contac">
                            <img src={logoWhatsApp} alt="logoWhatsApp" />
                            <label>Whatsapp</label>
                        </button>
                    </div>}
                    <div className="div2-textarea">
                        <label>Descripción</label>
                        <textarea>esta es una prueba de produccion</textarea>
                    </div>
                </div>
                <div className="buttons-container-modal">
                    <button className="btn-acept-modal">Editar tarea</button>
                </div>
            </Modal>
            <Modal isOpen={isModalOpenFinishTarea} onClose={closeModalFinishTarea}>
                <div className="modal-title">
                    <div className="head-task-label">
                        <button className="finish-task-btn">
                            <img src={checkmark} alt="checkmark" class="imagen-estandar" />
                            Finalizada
                        </button>
                    </div>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <label>tarea prueba</label>
                    </div>
                    <div className="card2-data-container">
                        <div className="container-data-asesor">
                            <div className="cuadrado inicial">
                                <label>R</label>
                            </div>
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>Rodrigo Lopez</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {rol === 'Coordinador' && <div className="buttons-prospects-tasks">
                        <button className="btn-prosp">
                            <img src={personTask} alt="personTask" />
                            <label>Prospecto</label>
                        </button>
                        <button className="btn-contac">
                            <img src={logoWhatsApp} alt="logoWhatsApp" />
                            <label>Whatsapp</label>
                        </button>
                    </div>}
                    <div className="div2-textarea">
                        <label>Descripción</label>
                        <textarea>esta es una prueba de produccion</textarea>
                    </div>
                </div>
                <div className="buttons-container-modal">
                    <button className="btn-acept-modal">Editar tarea</button>
                </div>
            </Modal>
        </>
    )
}

export { Tareas }